import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleSessionService implements OnDestroy {
  timeoutCountdown$: Subject<number> = new Subject<number>();
  isIdle$: Subject<boolean> = new Subject<boolean>();

  private countdownTimer: any = null;
  private logoffTime = 0;
  private loggingOut = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly idleService: Idle,
    private readonly authService: AuthService,
    private readonly ngZone: NgZone
  ) {}

  initialize(idleInSeconds: number, timeoutInSeconds: number = 0): void {
    this.destroyInternal();

    this.idleService.setIdle(idleInSeconds);
    this.idleService.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.subscriptions = [
      this.idleService.onIdleEnd.subscribe(() => {
        this.reset();
      }),
      this.idleService.onIdleStart.subscribe(() => {
        this.ngZone.run(() => this.isIdle$.next(true));
        this.beginCountdown(timeoutInSeconds);
      })
    ];

    this.reset();
  }

  reset(): void {
    this.clearCountdown();
    this.idleService.watch();
    this.ngZone.run(() => this.isIdle$.next(false));
    this.loggingOut = false;
  }


  ngOnDestroy(): void {
    this.destroyInternal();
  }

  private beginCountdown(timeoutInSeconds: number): void {
    if (timeoutInSeconds <= 0) {
      this.triggerLogout();
      return;
    }

    this.logoffTime = Date.now() + timeoutInSeconds * 1000;
    this.clearCountdown();

    this.countdownTimer = setInterval(() => {
      const remainingSeconds = Math.ceil((this.logoffTime - Date.now()) / 1000);

      if (remainingSeconds <= 0) {
        this.clearCountdown();
        this.triggerLogout();
      } else {
        this.timeoutCountdown$.next(remainingSeconds);
      }
    }, 500);
  }

  private triggerLogout(): void {
    if (this.loggingOut) {
      return;
    }

    this.loggingOut = true;
    this.authService.logOut('timeout');
  }

  private clearCountdown(): void {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }

  private destroyInternal(): void {
    this.clearCountdown();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }
}

